import { type FlexProps } from '../types'

export const crossAxisAlignmentToClassNameMap: Record<
  NonNullable<FlexProps['crossAxisAlignment']>,
  string
> = {
  start: 'align-items-start',
  center: 'align-items-center',
  end: 'align-items-end',
  stretch: 'align-items-stretch',
}

export const mainAxisAlignmentToClassNameMap: Record<
  NonNullable<FlexProps['mainAxisAlignment']>,
  string
> = {
  start: 'justify-content-start',
  center: 'justify-content-center',
  end: 'justify-content-end',
  spaceBetween: 'justify-content-space-between',
  spaceAround: 'justify-content-space-around',
  spaceEvenly: 'justify-content-space-evenly',
}

export const gapToClassNameMap: Record<NonNullable<FlexProps['gap']>, string> = {
  '0x': 'gap-0x',
  '0.5x': 'gap-0.5x',
  '1x': 'gap-1x',
  '2x': 'gap-2x',
  '3x': 'gap-3x',
  '4x': 'gap-4x',
  '6x': 'gap-6x',
  '8x': 'gap-8x',
  '9x': 'gap-9x',
  '10x': 'gap-10x',
  '12x': 'gap-12x',
  '16x': 'gap-16x',
  '20x': 'gap-20x',
  '24x': 'gap-24x',
  '32x': 'gap-32x',
}
